<div class="row">
  <div class="col-xs-12 l-pt-5">
    <cds-button [config]="config" label="{{ 'common.backToTop' | lang }}" (click)="backTop()"></cds-button>
  </div>
</div>
